import type { IControl } from '@eureka/utils/control';
import { controlDeferred } from '@eureka/utils/control';
import { type IPackageType } from '@eureka/services/src/apis/common.api.types';
import { packageInfoDeferred } from '@eureka/utils/package-info';
import { computed, ref } from 'vue';
import { checkJpEnv } from '@eureka/utils/check-jp-env';
import { createSharedComposable, tryOnBeforeMount } from '@vueuse/core';
import { accountDeferred, isUserLogin } from '@eureka/utils/account';
import type { Account } from '@patsnap-utils/biz';

export const usePlg = createSharedComposable(() => {
    const packageInfo = ref<IPackageType[]>([])
    const control = ref<IControl>()
    const isLogined = ref<boolean>(false)
    const account = ref<Account | null>(null);

    // 判断是否为 LsPLG 用户，模板中判断
    const isLsPlg = computed(() => {
        return control.value?.isLsPlg;
    });

    // 获取 PLG 用户角色，模板中判断
    const lsPlgRole = computed(() => {
        return control.value?.ls_plg_role;
    });

    // 判断是否为 PLG 基础版用户
    const isPlgBasic = computed(() => {
        return lsPlgRole.value === 'personal_basic';
    });

    const isPro = computed(() => {
        return lsPlgRole.value === 'personal_pro';
    });

    const isCompanyUser = computed(() => {
        return !!account.value?._info.company_id
    })

    const isCreditsAvailable = computed(() => {
        return control.value?.credit_package;
    })

    const isCountPackageAvailable = computed(() => {
        return control.value?.count_package;
    })

    // 判断是否为 LsPLG 用户
    const checkIsLsPlg = async function() {
        await controlDeferred.promise;
        return isLsPlg.value;
    };

    // 获取 PLG 用户角色
    const getLsPlgRole = async function() {
        await controlDeferred.promise;
        return lsPlgRole.value;
    };

    // 判断是否为 PLG 基础版用户
    const checkIsPlgBasic = async function() {
        await controlDeferred.promise;
        return isPlgBasic.value;
    };

    const isJPEnv = computed(() => {
        return checkJpEnv();
    })

    tryOnBeforeMount(async() => {
        isLogined.value = await isUserLogin();
        if (isLogined.value) {
            packageInfo.value = await packageInfoDeferred.promise;
        }
        control.value = await controlDeferred.promise;
        account.value = await accountDeferred.promise;
    })

    return {
        isLsPlg,
        lsPlgRole,
        isPlgBasic,
        isPro,
        isCompanyUser,
        checkIsLsPlg,
        getLsPlgRole,
        checkIsPlgBasic,
        isJPEnv,
        isCreditsAvailable,
        isCountPackageAvailable,
    }
})
